import { CCol, CModalBody, CModalHeader, CRow } from '@coreui/react'
import { forwardRef, useCallback, useImperativeHandle, useState } from 'react'
import { CModalExt } from '~/Components/CModalExt.js'
import { VariablesTable } from '~/Components/VariablesTable.js'

export interface ConnectionVariablesModalRef {
	show(label: string): void
}

export const ConnectionVariablesModal = forwardRef<ConnectionVariablesModalRef>(
	function ConnectionVariablesModal(_props, ref) {
		const [connectionLabel, setConnectionLabel] = useState<string | null>(null)
		const [show, setShow] = useState(false)

		const doClose = useCallback(() => setShow(false), [])
		const onClosed = useCallback(() => setConnectionLabel(null), [])

		useImperativeHandle(
			ref,
			() => ({
				show(label) {
					setConnectionLabel(label)
					setShow(true)
				},
			}),
			[]
		)

		return (
			<CModalExt visible={show} onClose={doClose} onClosed={onClosed} size="xl" scrollable>
				<CModalHeader closeButton>
					<h5>Variables for {connectionLabel}</h5>
				</CModalHeader>
				<CModalBody className="variables-table-modal-body">
					<CRow>
						<CCol lg={12}>{connectionLabel && <VariablesTable label={connectionLabel} />}</CCol>
					</CRow>
				</CModalBody>
			</CModalExt>
		)
	}
)
